import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ImproveQuality = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_23092_249786)">
          <path
            d="M4.28955 11.25C5.78955 14 9.03955 15 13.5396 12.75C11.9396 11.75 6.70622 11.3333 4.28955 11.25Z"
            fill={color}
            stroke={color}
            strokeLinejoin="round"
          />
          <path
            d="M8.53955 12.5C4.53955 15.75 2.28955 7 2.28955 3.75C4.03955 4.75 8.5625 4.34375 9.875 3.90625C10.375 8.15625 12.7188 11.0938 14.5396 11.75C13.7896 13 10.8125 14.5 8.53955 12.5Z"
            fill="white"
            stroke={color}
            strokeLinejoin="round"
          />
          <path
            d="M5.82812 10.5156L6.79688 11.4219L7.625 9.29688"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.3396 6.51562L6.30095 8.03385M6.03217 6.51562L4.76093 8.17188"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.60042 8.41596L9.21382 11.2652L11.6147 9.68301L15.5426 3.43862C15.8925 2.88238 15.7252 2.14782 15.169 1.79793C14.6127 1.44805 13.8782 1.61533 13.5283 2.17157L9.60042 8.41596Z"
            fill="white"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M14.7187 4.54687L13.0074 3.29684" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_23092_249786">
            <rect width={size} height={size} fill="white" transform="translate(0.977051)" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default ImproveQuality
